module.exports = __webpack_public_path__ + "static/media/Sidebar.4af6ae79.jpg";